// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import NomineeDetailsActionType from './basic-nominee-details.types';

const INITIAL_STATE = {
	// Nominee Details Response
	nomineeDetailsResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** NOMINEE DETAILS ADD START *********************** */
		case NomineeDetailsActionType.NOMINEE_DETAILS_ADD_SUCCESS:
			return { ...state, nomineeDetailsResponse: action.payload };

		case NomineeDetailsActionType.NOMINEE_DETAILS_ADD_FAILURE:
			return { ...state, nomineeDetailsResponse: action.payload };

		case NomineeDetailsActionType.NOMINEE_DETAILS_ADD_RESPONSE_CHANGED:
			return { ...state, nomineeDetailsResponse: null };
		/** ***************** NOMINEE DETAILS ADD END *********************** */

		default:
			return state;
	}
};
